/** Misure del layout email per-browser (localStorage, chiave per utente). */
export interface EmailLayoutMisure {
  listaW?: number;
  listaH?: number;
}

export const LISTA_W_DEFAULT = 360;
export const LISTA_H_DEFAULT = 320;
export const LISTA_W_MIN = 240;
export const LISTA_W_MAX = 800;
export const LISTA_H_MIN = 160;
export const LISTA_H_MAX = 600;

/** Misura letta dallo storage: non numerica o non finita -> default, poi clamp. */
export function clampMisura(
  v: number | undefined,
  min: number,
  max: number,
  def: number
): number {
  if (typeof v !== 'number' || !Number.isFinite(v)) return def;
  return Math.min(max, Math.max(min, v));
}

const chiave = (userId: string) => `floraltech.email.layout.${userId}`;

export function leggiLayout(userId: string | undefined): EmailLayoutMisure {
  if (!userId) return {};
  try {
    const raw = localStorage.getItem(chiave(userId));
    const val: unknown = raw ? JSON.parse(raw) : {};
    if (typeof val !== 'object' || val === null || Array.isArray(val)) return {};
    return val as EmailLayoutMisure;
  } catch {
    return {};
  }
}

export function salvaLayout(userId: string | undefined, misure: EmailLayoutMisure): void {
  if (!userId) return;
  try {
    localStorage.setItem(
      chiave(userId),
      JSON.stringify({ ...leggiLayout(userId), ...misure })
    );
  } catch {
    /* quota o storage disabilitato: preferenza volatile, nessun errore utente */
  }
}
